import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import EventGuestlistStatsRequests from "../EventGuestlistStatsRequests";
import { Tab, Tabs } from "react-bootstrap";
import GuestlistStatsView from "./views/GuestlistStatsView";
import PromotersStatsView from "./views/PromotersStatsView";
import TableStatsView from "./views/TableStatsView";
import NavBar from "../../../../../../components/NavBar";
import TicketsStatsView from "./views/TicketsStatsView";
import { tab } from "@testing-library/user-event/dist/tab";
import FinancialView from "./views/FinancialView";

const StatsPage = () => {
  const { state } = useLocation();
  let params = useParams();
  const [activeTab, setActiveTab] = useState('guestlist'); // Aba padrão

  const handleSelect = (key) => {
    setActiveTab(key); // Atualiza a aba ativa
  };
  const [data, setData] = useState({
    // guestlist: {
    //   numberRegistries: 0,
    //   numberEntries: 0,
    //   taxSuccess: 0,
    //   genres: [],
    //   ages: [],
    //   list_entries: []
    // },
    guestlist: null,
    promoters: null,
    tables: null,
    tickets: null
  });
  const fetchStats = async () => {
    let info =
      await EventGuestlistStatsRequests.getEventGuestlistStatsEntries({ ...params, tab: activeTab });
    if (info && info.status) {
      setData(info.data);
    }
  };
  useEffect(() => {
    document.title = "Event Stats | Nightspot Dashboard";

    fetchStats();
  }, [params, activeTab]);


  return (
    <div>
      <NavBar>
        <div className="row">
          <div className="col-sm-12 dashboard-content">
            <div className="row">
              <div className="col-12">
                <nav>
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/my/dashboard">
                        <i className="fa-solid fa-home"></i>
                      </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/my/events/">Eventos</Link>
                    </li>
                    <li className="breadcrumb-item active">Estatísticas {state?.item?.name ? "- " + state?.item?.name : ""}</li>
                  </ol>
                </nav>
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-12">
                <div className="tab">
                  <Tabs
                    defaultActiveKey="guestlist"
                    id="justify-tab-example"
                    className="tab-nested"
                    justify
                    onSelect={handleSelect}
                  >
                    <Tab eventKey="guestlist" title="Guest List">
                      <GuestlistStatsView data={data.guestlist} />
                    </Tab>
                    <Tab eventKey="promoters" title="Promotores">
                      <PromotersStatsView data={data.promoters} />
                    </Tab>
                    <Tab eventKey="tables" title="Mesas">
                      <TableStatsView
                        data={data.tables}
                      />
                    </Tab>
                    <Tab eventKey="tickets" title="Bilhetes">
                      {/* <h1>Coming Soon</h1> */}
                      <TicketsStatsView data={data.tickets} />
                    </Tab>
                    <Tab eventKey="financial" title="Financeiro">
                      {/* <h1>Coming Soon</h1> */}
                      <FinancialView data={data.financial} />
                    </Tab>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </NavBar>
    </div>
  );
};

export default StatsPage;
